export default {
  walletTransactions: 'Cüzdan İşlemleri',
  date: 'Tarih',
  transactionTime: 'İşlem Zamanı',
  nameLastname: 'Ad Soyad',
  transactionType: 'İşlem Türü',
  amount: 'Tutar ($)',
  routeName: 'Güzergah Adı',
  campusArrival: 'Kampüs Varış',
  campusDeparture: 'Kampüs Kalkış',
  boardingStop: 'Biniş Durağı',
  campus: 'Kampüs',
  idNumber: 'Sicil No',
  department: 'Departman',
  transactionTypes: {
    TOPUP: 'Yükleme',
    TOPUP_BY_ADMIN: 'Admin Tarafından Yükleme',
    DEDUCT_BY_ADMIN: 'Admin Tarafından Düşme',
    SHUTTLE: 'Servis Geçişi',
    PASS_PACKAGE_PAYMENT: 'Pass Paket Ödemesi',
    SHUTTLE_PASS_PACKAGE: 'Servis Geçişi Paketi',
    PASS_PACKAGE_PURCHASE: 'Pass Paket Satın Alma',
  },
  adjustWalletBalance: 'Cüzdan Bakiyesini Ayarla',
  topUpWallet: 'Cüzdana Yükle',
  selectEnterAmount: 'Tutar Seçin/Girin',
  enterAmount: 'Tutar Girin',
  topUpAmount: 'Tutar Seçin',
  topUpSuccess: '{0} yolcu için yükleme başarılı.',
  topUpPartialSuccess: '{0} yolcu için yükleme başarılı. {1} yolcu için başarısız.',
  topUpFailed: 'Seçili tüm yolcular için yükleme başarısız.',
  topUp: 'Yükle',
  add: 'Ekle',
  deduct: 'Düş',
  notes: 'Notlar',
  addNotes: 'Not ekleyin',
  amountRange: 'Tutar {0} ile {1} arasında olmalıdır',
  topUpsByRiders: 'Yolcular Tarafından Yükleme',
  topUpsByAdmins: 'Adminler Tarafından Yükleme',
  tripPasses: 'Servis Geçişleri',
  passPackagePurchase: 'Pass Paket Satın Alma',
};
